import { defineStore } from "pinia";

export const useCounterStore = defineStore("counter", {
  state: () => ({
    counters: [] as { name: string; count: number }[]
  }),

  actions: {
    increment(name: string): number {
      const existing = this.counters.find((counter) => counter.name === name);
      if (existing) {
        return ++existing.count;
      }
      this.counters.push({ name, count: 1 });
      return 1;
    },

    decrement(name: string): number {
      const existing = this.counters.find((counter) => counter.name === name);
      if (existing) {
        existing.count = Math.max(0, existing.count - 1);
        return existing.count;
      }
      this.counters.push({ name, count: 0 });
      return 0;
    },

    count(name: string): number {
      const existing = this.counters.find((counter) => counter.name === name);
      return existing?.count ?? 0;
    }
  }
});
